export default "__VITE_ASSET__fYBjjN4V__"